import { Paper, Skeleton, Group } from '@mantine/core';
import React from 'react';

export const FormSkeleton: React.FC = () => {
  return (
    <Paper p="md" withBorder>
      <Skeleton height={30} mb="md" width="70%" />
      <Skeleton height={300} mb="md" radius="sm" />
      <Skeleton height={20} mb="sm" width="90%" />
      <Skeleton height={20} mb="sm" width="80%" />
      <Group mb="md">
        <Skeleton height={36} width={120} />
        <Skeleton height={36} width={150} />
      </Group>
    </Paper>
  );
};
